import { handleResponse, handleError, headerset } from "../apiUtils";

// ============================================
// BASE URL
// ============================================

const baseUrl = () => {
    return process.env.API_URL + "/api/personale/operatori/";
};

// ============================================
// API FUNCTIONS
// ============================================

/**
 * Fetch lista operatori
 */
export function fetchOperatori() {
    const url = baseUrl() + "?numero_record=200";

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}
